import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgMinIcontext = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 24 24",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M4,3 L4,5 L20,5 L20,3 L4,3 Z M8.3225,9.436 L8.3225,7.889 L8.2665,7.889 L7.2375,10.402 L6.2085,7.889 L6.1525,7.889 L6.1525,9.436 L6.1525,11.886 L5.6135,11.886 L5.6135,7 L6.3695,7 L7.2305,9.156 L7.2725,9.156 L8.1335,7 L8.8615,7 L8.8615,11.886 L8.3225,11.886 L8.3225,9.436 Z M10.3005,11.886 L10.3005,11.417 L11.5185,11.417 L11.5185,7.469 L10.3005,7.469 L10.3005,7 L13.3245,7 L13.3245,7.469 L12.1065,7.469 L12.1065,11.417 L13.3245,11.417 L13.3245,11.886 L10.3005,11.886 Z M15.4285,7.749 L15.3795,7.749 L15.3795,11.886 L14.8475,11.886 L14.8475,7 L15.6805,7 L17.3465,11.095 L17.3955,11.095 L17.3955,7 L17.9275,7 L17.9275,11.886 L17.0945,11.886 L15.4285,7.749 Z M16,16.886 L13,16.886 L13,13.886 L11,13.886 L11,16.886 L8,16.886 L12,20.886 L16,16.886 Z",
		fill: "currentColor"
	})
});
export default SvgMinIcontext;
